var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"stripe-status-tag",class:`stripe-status-tag--${_vm.tone}`},[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }